import { Box, useMediaQuery } from "@mui/material";
import ActivityDistribution from "./ActivityDistribution";
import DailyActivityTrends from "./DailyActivityTrends";
import { FC } from "react";
import { ILoginActivity } from "../../../models/admin/loginActivity/loginActivity";
interface ILoginRecordProps {
  loginActivity: ILoginActivity[];
}
const LoginRecords: FC<ILoginRecordProps> = ({ loginActivity = [] }) => {
  const isMobile = useMediaQuery("(max-width:767px)");
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: 3,
          width: "100%",
          maxWidth: isMobile ? "calc(100vw - 48px)" : "none",
        }}
        id="login_records_container"
        data-test-id="login_records_container"
        aria-label="Login Records Container"
      >
        <ActivityDistribution filteredData={loginActivity} />
        <DailyActivityTrends filteredData={loginActivity} />
      </Box>
    </>
  );
};

export default LoginRecords;
